import { useEffect, useState } from 'react';
import { getAuth, onAuthStateChanged, signInWithEmailAndPassword } from 'firebase/auth';
import { initFirebase } from '@/lib/firebase';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { useNavigate, Link } from 'react-router-dom';

export default function LoginPage() {
  const [ready, setReady] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      const ctx = await initFirebase();
      if (!ctx) return;
      const auth = getAuth();
      const unsub = onAuthStateChanged(auth, (u) => {
        if (u) navigate('/');
        else setReady(true);
      });
      return () => unsub();
    })();
  }, []);

  async function doLogin(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    try {
      const auth = getAuth();
      await signInWithEmailAndPassword(auth, email, password);
      navigate('/');
    } catch (e: any) {
      setError(e?.message || 'ログインに失敗しました');
    }
  }

  if (!ready) return null;

  return (
    <div className="min-h-screen bg-background grid place-items-center p-4">
      <Card className="w-full max-w-sm p-6 border-0 shadow-card">
        <h1 className="text-xl font-semibold mb-4">ログイン</h1>
        <form className="space-y-3" onSubmit={doLogin}>
          <div className="space-y-1">
            <label className="text-sm">メールアドレス</label>
            <Input value={email} onChange={(e) => setEmail(e.target.value)} inputMode="email" autoComplete="email" required />
          </div>
          <div className="space-y-1">
            <label className="text-sm">パスワード</label>
            <Input value={password} onChange={(e) => setPassword(e.target.value)} type="password" autoComplete="current-password" required />
          </div>
          {error && <div className="text-xs text-red-600">{error}</div>}
          <Button type="submit" className="w-full">ログイン</Button>
        </form>
        <div className="text-sm text-muted-foreground mt-3">
          アカウントが必要ですか？ <Link className="text-primary underline" to="/register">新規登録へ</Link>
        </div>
      </Card>
    </div>
  );
}

